// @ts-expect-error pure js
import useResource from "./use-resource";
import type { AuthorizeInfo } from "../models/oauthAuthorize";

const INFO_PATH = "oauth/authorize/info";
const GRANT_PATH = "oauth/authorize/grant";

export default function useOAuthAuthorize(
  params: Record<string, string>,
  enabled: boolean,
) {
  const { resource, error, isLoading, axios } = useResource(
    enabled ? INFO_PATH : null,
    { params },
  );

  async function grant(grantedScopes: string[]): Promise<string> {
    const response = await axios.post(GRANT_PATH, {
      ...params,
      granted_scopes: grantedScopes,
    });
    return response.data.redirect_uri;
  }

  return {
    info: resource as AuthorizeInfo | null,
    error: error as Error | undefined,
    isLoading: isLoading as boolean,
    grant,
  };
}
